export default "__VITE_ASSET__gHfZZN30__"